function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import BaseTheme, { generateShadows } from './baseTheme';
var colors = {
  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#446b7c',
  borderDarkest: '#000814',
  borderLight: '#adc8da',
  borderLighter: '#d1e0ea',
  borderLightest: '#e5edf3',
  canvas: '#00010f',
  canvasText: '#f2ffff',
  canvasTextDisabled: '#446b7c',
  canvasTextDisabledShadow: '#c3d9e9',
  canvasTextInvert: '#f2ffff',
  headerBackground: '#448199',
  headerNotActiveBackground: '#807f80',
  headerNotActiveText: '#c2c1c2',
  headerText: '#f2ffff',
  material: '#97b9cb',
  materialDark: '#9a9e9c',
  materialText: '#00010f',
  materialTextDisabled: '#446b7c',
  materialTextDisabledShadow: '#c3d9e9',
  materialTextInvert: '#f2ffff',
  progress: '#448199',
  inputBackground: '#ffffff',
  inputBackgroundDisabled: '#adc8da',
  tooltip: '#fefbcc'
};

var slate = _objectSpread(_objectSpread({}, BaseTheme), {}, {
  colors: colors,
  shadows: generateShadows(colors)
});

export default slate;